export const CancelOrderType = {
    CANCEL_1    : 1,
    CANCEL_2    : 2,
    CANCEL_3    : 3,
}

export const cancelOrderTypes = [
    {
        key: CancelOrderType.CANCEL_1,
        label: "Change of mind",
    },
    {
        key: CancelOrderType.CANCEL_2,
        label: "Unable to make payment",
    },
    {
        key: CancelOrderType.CANCEL_3,
        label: "Shipping fee too high",
    },
]